import classNames from 'classnames';
import { SearchIcon } from 'lucide-react';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import i18n from '@/settings/i18n';
import TradeInButton from './TradeInButton';

const t = i18n.init('shared');

const MobileSearchTrigger = ({
  setShowSearchModal,
  search,
}: {
  setShowSearchModal: Dispatch<SetStateAction<boolean>>;
  search?: string;
}) => {
  const [hidden, setHidden] = useState(false);
  const lastScrollY = useRef(0);
  const ticking = useRef(false);
  const lockedUntil = useRef(0);

  useEffect(() => {
    const update = () => {
      ticking.current = false;

      const now = Date.now();
      const currentScrollY = window.scrollY;

      if (now < lockedUntil.current) {
        lastScrollY.current = currentScrollY;

        return;
      }

      const delta = currentScrollY - lastScrollY.current;

      if (Math.abs(delta) < 10) {
        return;
      }

      const shouldHide = delta > 0 && currentScrollY > 80;

      lastScrollY.current = currentScrollY;

      setHidden((prev) => {
        if (prev !== shouldHide) {
          lockedUntil.current = now + 350;
        }

        return shouldHide;
      });
    };

    const onScroll = () => {
      if (ticking.current) {
        return;
      }

      ticking.current = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className={classNames(
        'reebelo-container overflow-hidden transition-all duration-300 ease-in-out',
        hidden ? 'max-h-0 opacity-0' : 'max-h-20 opacity-100',
      )}
    >
      <div className="flex items-center gap-2 pb-2">
        <button
          className="flex h-10 flex-1 cursor-text items-center gap-2 rounded-full bg-gray-200 px-4 text-left text-[13px] outline-none"
          onClick={() => setShowSearchModal(true)}
        >
          <SearchIcon className="h-5 w-5 shrink-0" />
          <span
            className={classNames('', {
              'text-gray-700/60': !search,
            })}
          >
            {search || t`Search by model, brand, color…`}
          </span>
        </button>
        <TradeInButton />
      </div>
    </div>
  );
};

export default MobileSearchTrigger;
